import React from 'react'
// This is the index page banner
const Banner = (props) => (
    <section id="banner" className="major index-banner">
        <div className="inner">
            <header className="betway-header">
                <h3>Betaway enters the scene</h3>
            </header>
            <div className="content">
                <p>Having partnered up with the PPF (the Professional Players Federation), an organisation body which is dedicated to the development, 
                protection and promotion of professional sportsmen and women’s collective interests across the UK.</p>
                 
                <p>Betway is set to financially contribute to new educational initiatives that the organisation will be putting in place.
                Betway’s support will come in the form of a long-term arrangement to assist in the funding of tutors and e-learning programmes which will 
                allow for the delivery of critical athlete training.</p>

                <p>Betway’s CEO expressed his excitement at joining the 
                project, stating how much he was <a href="http://www.igamingbusiness.com/news/betway-calls-clean-sports-betting-environment" class="highlight-link" target="_blank" rel="follow">looking forward to the sportsbook’s opportunity to support</a> the PPF’s vital work both now and in the future.</p>
            </div>
        </div>
    </section>
)

export default Banner



// WEBPACK FOOTER //
// ./src/components/Banner.js